import { Link } from "react-router-dom";
import { FiInstagram } from "react-icons/fi";
import { SiTiktok } from "react-icons/si";
import PageContainer from "./PageContainer";

const Footer = () => {
  return (
    <footer className="mt-16 border-t border-goldlight bg-soft-cream">
      <PageContainer className="py-10">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <h3 className="text-xl font-semibold text-henna">Nayra Henna</h3>

            <p className="mt-3 text-sm leading-6 text-muted-warm">
              Beautiful henna for weddings, celebrations, and personal moments,
              with a booking experience designed to feel simple and welcoming.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-golddeep">
              Quick Links
            </h4>

            <div className="mt-4 flex flex-col gap-2 text-sm text-muted-warm">
              <Link to="/" className="transition-colors hover:text-henna">
                Home
              </Link>

              <Link to="/services" className="transition-colors hover:text-henna">
                Services
              </Link>

              <Link to="/booking" className="transition-colors hover:text-henna">
                Book Your Appointment
              </Link>

              <Link to="/gallery" className="transition-colors hover:text-henna">
                Gallery
              </Link>

              <Link to="/contact" className="transition-colors hover:text-henna">
                Contact
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-golddeep">
              Follow the Artist
            </h4>

            <p className="mt-3 text-sm text-muted-warm">
              Follow along for the latest designs, inspiration, and updates from
              Nayra Henna.
            </p>

            <div className="mt-4 flex flex-col gap-3">
              <a
                href="https://www.instagram.com/nayra.heena/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-fit items-center gap-2 rounded-full border border-goldlight px-4 py-2 text-sm text-henna transition hover:bg-white hover:shadow-soft"
              >
                <FiInstagram size={18} />
                Nayra Henna Instagram
              </a>

              <a
                href="https://www.tiktok.com/@nayra.henna"
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-fit items-center gap-2 rounded-full border border-goldlight px-4 py-2 text-sm text-henna transition hover:bg-white hover:shadow-soft"
              >
                <SiTiktok size={18} />
                Nayra Henna TikTok
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-goldlight pt-6 text-center text-xs text-muted-warm">
          © {new Date().getFullYear()} Nayra Henna. All rights reserved.
        </div>
      </PageContainer>
    </footer>
  );
};

export default Footer;